/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineParseIssue {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineParseIssue.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineParseIssue>): AIUnitEconomicsBaselineParseIssue {
        let obj = Object.assign(new AIUnitEconomicsBaselineParseIssue(), model);
        AIUnitEconomicsBaselineParseIssue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineParseIssue>): AIUnitEconomicsBaselineParseIssue {
        if (!model) return null;
        return AIUnitEconomicsBaselineParseIssue.newInstance(<AIUnitEconomicsBaselineParseIssue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineParseIssue) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineParseIssue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineParseIssue): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineParseIssue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.row === undefined) {
            this.row = 0;
        }
    }

    /**
     * 1-based spreadsheet row number, counting the header row
     */
    row: number;

    /**
     * What is wrong with the row
     */
    message: string;

}
